"use client";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { LicenseInfo } from "@mui/x-license-pro";
var version = "v2.6.4";
export var apiVersion = "v2.1";
var apiVersionInitial = "v2-1";
export var env = "prod";
LicenseInfo.setLicenseKey("108e1b12d0f5bbd6e965f9f86b9b9f43Tz0xMTExODcsRT0xNzc1ODY1NTk5MDAwLFM9cHJlbWl1bSxMTT1wZXJwZXR1YWwsUFY9aW5pdGlhbCxLVj0y");
export default function MuiXLicense() {
    return null;
}
;
export var envConfig = function () {
    if (window.location.hostname === 'localhost' && !['dev', 'prod'].includes(env)) {
        return {
            baseURL: "https://api-".concat(env, "-yuj.excellonconnect.com/").concat(apiVersion, "/"),
            version: "".concat(env === null || env === void 0 ? void 0 : env.toLocaleUpperCase(), "-") + version,
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            WS_BASE_URL: "wss://api-".concat(env, "-yuj.excellonconnect.com/")
        };
    }
    if (env === "dev") {
        return {
            // baseURL: `https://dev-idms-${apiVersionInitial}.excellonconnect.com/${apiVersion}/`,
            baseURL: "https://api-yuj.excellonconnect.com/".concat(apiVersion, "/"),
            version: 'DEV-' + version,
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            //vahan
            // Subscription: "177881c0-4f30-41f0-a949-a7df2fa63d8a", //dharti
            WS_BASE_URL: "wss://dev-idms-".concat(apiVersionInitial, ".excellonconnect.com/")
        };
    }
    else if (env === "qa") {
        return {
            baseURL: "https://qa-idms.excellonconnect.com/v2.0/",
            version: 'QA-' + version,
            // Subscription: "177881c0-4f30-41f0-a949-a7df2fa63d8a",
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            //vahan
            WS_BASE_URL: "wss://qa-idms.excellonconnect.com/"
        };
    }
    else if (env === "uat") {
        return {
            baseURL: "https://api-".concat(env, "-yuj.excellonconnect.com/").concat(apiVersion, "/"),
            // baseURL: `https://uat-idms.excellonconnect.com/v2.0/`,
            version: 'UAT-' + version,
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            WS_BASE_URL: "wss://uat-idms.excellonconnect.com/"
        };
    }
    else if (env === "lt") {
        return {
            baseURL: "https://lt-idms.excellonconnect.com/v2.0/",
            version: 'LT-' + version,
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            WS_BASE_URL: "wss://lt-idms.excellonconnect.com/"
        };
    }
    else if (env === "prod") {
        return {
            baseURL: "https://bal-idms.excellonconnect.com/v2.0/",
            version: version,
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            WS_BASE_URL: "wss://bal-idms.excellonconnect.com/"
        };
    }
    else if (env === "prod-live") {
        return {
            baseURL: "https://live-bal-idms.excellonconnect.com/".concat(apiVersion, "/"),
            version: 'PROD-Live-' + version,
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            WS_BASE_URL: "wss://live-bal-idms.excellonconnect.com/"
        };
    }
    else {
        return {
            baseURL: "https://api-qa-yuj.excellonconnect.com/".concat(apiVersion, "/"),
            version: 'QA-' + version,
            Subscription: "39e59d4c-070f-4566-af92-d4230836c0ec",
            WS_BASE_URL: "wss://api-qa-yuj.excellonconnect.com/"
        };
    }
};
export var Config = _objectSpread(_objectSpread({}, envConfig()), {}, {
    ClientID: "1249f424-a0f0-47a9-b1c5-a9f874bc092f",
    ClientSecret: "27421639-5133-4a62-a4c0-8da8e628bcac",
    GoogelMapAPIKey: "AIzaSyDpzWi_fOehkRUAYH_-WUYGE6l4rsUrbNs",
    apiKey: "AIzaSyAImTTqjV3FXGpiaTs5dRIS4bH_9XiqET8",
    authDomain: "pwa-service-app-30dca.firebaseapp.com",
    projectId: "pwa-service-app-30dca",
    storageBucket: "pwa-service-app-30dca.appspot.com",
    messagingSenderId: "456490580907",
    appId: "1:456490580907:web:1c80b163e8fdca9727f0ee",
    measurementId: "G-4J9L7S84JK",
    vapidKey: "BCTfFVmlr5MHx2qOd_nxAcqHUkpUqH6aqOtotSpUM7vAY409DNDZQVuh4ho1NOnDxLXtAGbcWhv1uvslJuWnh0Y",
    userId: "7c1a1849-ba9f-49c5-bd90-0f3ff996414f",
    //"5257a64c-0660-482a-ba79-31f9bc275d87",
    CDNBaseURL: "https://idmscdn.blob.core.windows.net/idms-ui-image/"
});
